import { render, staticRenderFns } from "./customsClearanceQuery.vue?vue&type=template&id=56bae0e8&scoped=true&"
import script from "./customsClearanceQuery.vue?vue&type=script&lang=js&"
export * from "./customsClearanceQuery.vue?vue&type=script&lang=js&"
import style0 from "./customsClearanceQuery.vue?vue&type=style&index=0&id=56bae0e8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56bae0e8",
  null
  
)

export default component.exports